import React from 'react';
import Modal from './Modal';

export default function ConfirmDialog({ title, message, confirmLabel = '확인', danger, onConfirm, onCancel }) {
  return (
    <Modal
      title={title}
      onClose={onCancel}
      width={360}
      footer={
        <>
          <button className="btn btn-secondary" onClick={onCancel}>취소</button>
          <button className={danger ? 'btn btn-danger' : 'btn btn-primary'} onClick={onConfirm}>{confirmLabel}</button>
        </>
      }
    >
      <p className="text-secondary">{message}</p>
    </Modal>
  );
}
